import { render, staticRenderFns } from "./TelecomTitleBlock.vue?vue&type=template&id=b28bc15e"
import script from "./TelecomTitleBlock.vue?vue&type=script&lang=js"
export * from "./TelecomTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./TelecomTitleBlock.vue?vue&type=style&index=0&id=b28bc15e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports